export default __webpack_public_path__ + "static/media/T_wdt_c_cap_0.f4ebf4d5.mp3";